export function clampQuantity(
  quantity: number,
  maxQuantity?: number,
  minQuantity: number = 1,
): number {
  const adjustedMin = Math.max(minQuantity, quantity);

  if (typeof maxQuantity === 'number') {
    return Math.min(maxQuantity, adjustedMin);
  }

  return adjustedMin;
}

export function parseQuantityInputRaw(
  input: string,
  minQuantity: number = 1,
): number {
  const parsedValue = parseInt(input, 10);

  return Number.isNaN(parsedValue) ? minQuantity : parsedValue;
}
